import { SessionContextDto, useGetSessionContextQuery } from '@common/services/session';

export function useSessionContext() {
  const { data: context } = useGetSessionContextQuery();
  return context as SessionContextDto;
}